// removed by extract-text-webpack-plugin
module.exports = {"buttonCancel":"UC9hpjiDy7xW9dfkhvqxM","buttonConfirm":"_15sQKiEnQEFuQjvLXSakCg"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Message/style.scss
// module id = 949
// module chunks = 0